import { render, staticRenderFns } from "./ChatBotModal.vue?vue&type=template&id=5fbe4ce2&scoped=true&"
import script from "./ChatBotModal.vue?vue&type=script&lang=js&"
export * from "./ChatBotModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotModal.vue?vue&type=style&index=0&id=5fbe4ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbe4ce2",
  null
  
)

export default component.exports